import Loader from "../Loader";

function SpinnerFullPage() {
    return (
        <div className="relative z-50 flex items-center justify-center h-screen overflow-hidden ">
            <Loader />
        </div>
    );
}

export default SpinnerFullPage;
